import React from 'react';
import { useDispatch } from 'react-redux';
import { getConfig } from '../../../apiConfig';
import { getEndpointUrl } from '../../../config';
import { simpleDate } from '../../../helpers/datetime';
import { formatPrice } from '../../../helpers/number';
import Button, {
	BUTTON_KIND_ACTION,
	BUTTON_KIND_TRANSPARENT,
} from '../../common/buttons/button/Button';
import { PDF, PAID, ACCOUNT_INVOICE_PERIOD, PAY_NOW } from '../../../constants/Copy';
import { analyticsPush } from '../../../actions/applicationActions';
import { EVT_PAY_OPEN_INVOICE_CLICKED_PAY } from '../../../constants/EventTypes';
import Icon from '../../common/icons/Icon';
import './SubscriptionCancelledInvoices.scss';
import { initiateTrackStructEvent } from '../../analytics/Snowplow';
import {
	EVT_BAD_DEBT,
	EVT_INVOICE_SELECT,
	EVT_ELEMENT_INTERACTION,
	EVT_INVOICE_OVERVIEW,
	EVT_ELEMENT_TYPE_BUTTON,
	EVT_INVOICE,
} from '../../../constants/SnowplowEvents';

function RenderPayInvoiceButton({ index, paid, invoice, origin }) {
	const dispatch = useDispatch();
	function handlePayInvoiceClick({ invoice, label }) {
		const payLink = invoice.openPayments[0]?.payLink;
		if (payLink) {
			window.location.href = `${payLink}&origin=${origin}`;
			initiateTrackStructEvent({
				category: EVT_BAD_DEBT,
				action: EVT_INVOICE_SELECT,
				label: label,

				rtlElementContext: {
					elementInteraction: EVT_ELEMENT_INTERACTION,
					elementGroup: EVT_INVOICE_OVERVIEW,
					elementType: EVT_ELEMENT_TYPE_BUTTON,
					elementName: EVT_INVOICE,
					elementLabel: label,
				},
			});
			dispatch(analyticsPush({ label, origin }, EVT_PAY_OPEN_INVOICE_CLICKED_PAY));
			return true;
		}
		return false;
	}

	const label = paid ? PAID : PAY_NOW;
	return (
		<Button
			data-test={`pay-invoice-button-${index}`}
			disabled={paid}
			kind={BUTTON_KIND_ACTION}
			onClick={() => handlePayInvoiceClick({ invoice, label })}
		>
			{label}
		</Button>
	);
}

const SubscriptionCancelledInvoiceListItem = ({ invoice, index, showPDFButton, origin }) => {
	const paid = invoice.outstandingBalance === 0 || !invoice.openPayments.length;
	return (
		<li key={invoice.number} className="invoices-list-item">
			<section className="invoice" data-test="invoice">
				<header className="invoice__header">
					<p className="invoice__headline">
						{invoice.headline}{' '}
						<span className="invoice__headline__price">{`\u20AC ${formatPrice(
							invoice.totalAmount
						)}`}</span>
					</p>
					<p className="invoice__date-text">
						{ACCOUNT_INVOICE_PERIOD}:{' '}
						<time className="invoice__date" dateTime={invoice.serviceStartDate}>
							{simpleDate(invoice.serviceStartDate)}
						</time>{' '}
						-{' '}
						<time className="invoice__date" dateTime={invoice.serviceEndDate}>
							{simpleDate(invoice.serviceEndDate)}
						</time>
					</p>
				</header>

				<RenderPayInvoiceButton index={index} paid={paid} invoice={invoice} origin={origin} />

				{showPDFButton && renderDownloadInvoiceButton(index, invoice.number)}
			</section>
		</li>
	);

	function renderDownloadInvoiceButton(index, invoiceNumber) {
		if (!invoiceNumber) return null;
		return (
			<Button
				data-test={`download-invoice-button-${index}`}
				kind={BUTTON_KIND_TRANSPARENT}
				href={getInvoiceDownloadUrl(invoiceNumber)}
			>
				<Icon
					className="invoice__download__icon"
					name="download_icon"
					width="12"
					height="12"
					viewBox="0 0 22 22"
				/>
				<span className="invoice__download__icon__text">{PDF}</span>
			</Button>
		);
	}
};

const getInvoiceDownloadUrl = (invoiceNumber) => {
	const { billing_base } = getConfig();
	const path = getEndpointUrl('invoiceDownloadPdf', { invoiceNumber });
	return `${billing_base}${path}`;
};

export default SubscriptionCancelledInvoiceListItem;
